// ##### 24-06-12 Komarov
import parse from 'html-react-parser';
import uniqueId from 'lodash.uniqueid';
// ##### Komarov 2025-07-22
import React, { useCallback } from 'react';
import { Media } from '../../../../../helpers/MediaConfig';
import { useMessagesObj } from '../../../../../helpers/messages';
// ##### 25-05-21 Komarov
import LogInLinkTag from '../../../../Library/Common/LogInLinkTag';
import HomeIcon from '../../../../Library/Icons/homeicon';
import Operations from '../../../../Library/Icons/operations';
import LocalizationNavLink from '../../../../Library/Localization/LocalizationNavLink';
import LargeScreensNavBar from '../LargeScreensNavBar';
// ##### 25-04-24 Komarov
import { useDispatch, useSelector } from 'react-redux';
import { unsetDevMode } from '../../../../../Redux/actions';

// ##### Komarov 2025-07-22
const TopMenuRightDivPartForDesktop = () => {
  const sitePagesObj = useMessagesObj();
  // ##### Komarov 2025-08-05
  const Home_icon = useSelector(state => state.pagesRedux[state.language]?.Home_icon || '');
  const Operations_icon = useSelector(state => state.pagesRedux[state.language]?.Operations_icon || '');
  // ##### 25-04-24 Komarov
  const devMode = useSelector(state => state.devMode);

  const dispatch = useDispatch();
  const handleOutDev = useCallback(() => {
    localStorage.removeItem('devKey');
    // ##### Komarov 2025-08-26
    // Удаляем cookie devMode
    document.cookie = 'devMode=; Path=/; Max-Age=0';
    dispatch(unsetDevMode());
  }, []);

  // ##### 24-06-12 Komarov
  return (
    <div
      className="topMenu_right"
      // ##### Komarov 2025-07-24
      data-component="TopMenuRightDivPartForDesktopSsr"
    >
      {/* ##### 23-11-01 Komarov */}
      <Media greaterThanOrEqual="Laptop-1024-1440">
        {/* ##### 24-06-20 Komarov */}
        {sitePagesObj.Header.UPPER && (
          <LargeScreensNavBar
            sitepage_type={sitePagesObj.Header.UPPER}
            linkClassName={'Upper'}
            key={() => uniqueId()}
          />
        )}
      </Media>
      {/* ##### 25-01-16 Komarov */}
      <Media
        greaterThanOrEqual="Laptop-1024-1440"
        style={{ display: 'flex', alignItems: 'center' }}
      >
        {/* ##### 23-04-05 Komarov: элемент Home */}
        {/* ##### 24-06-20 Komarov */}
        <LocalizationNavLink key={uniqueId()} exact to={''}>
          {Home_icon && <HomeIcon hintText={parse(Home_icon)} />}
        </LocalizationNavLink>

        {/* ##### 23-04-05 Komarov: элемент Operations */}
        { /* ##### Komarov 2025-07-24 */}
        <LocalizationNavLink key={uniqueId()} exact to={'/mybooking'}>
          {Operations_icon && <Operations
            // ##### 24-06-20 Komarov
            key={uniqueId()}
            hintText={parse(Operations_icon)}
          />}
          {/* ##### 24-03-21 Komarov */}
        </LocalizationNavLink>

        {/* ##### 23-04-05 Komarov: элемент Login */}
        <LogInLinkTag className="" right="9rem" />
        {/* ##### 25-04-24 Komarov: кнопка для выхода из режима Разработчика */}
        {devMode && (
          <button
            onClick={handleOutDev}
            style={{
              marginLeft: '10px',
              padding: '4px 8px',
              backgroundColor: '#ff4444',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '12px',
              fontWeight: 'bold',
            }}
          >
            outDev
          </button>
        )}
      </Media>
    </div>
  );
};

export default TopMenuRightDivPartForDesktop;
